import { FiTruck, FiRepeat } from 'react-icons/fi';

interface CaseStudy {
  storeName: string;
  industry: string;
  url?: string;
  logo?: string;
  metrics: {
    label: string;
    value: string;
    description: string;
    icon: React.ReactNode;
  }[];
  quote?: string;
  quoteName?: string;
}

const caseStudies: CaseStudy[] = [
  {
    storeName: "Noa",
    industry: "Health Supplements",
    url: "https://mynoalife.com/",
    logo: "/noa.png",
    metrics: [
      {
        label: "RTO Reduction",
        value: "36%",
        description: "Fewer returns to origin",
        icon: <FiTruck className="w-5 h-5" />,
      },
      {
        label: "Retention",
        value: "+25%",
        description: "More repeat customers",
        icon: <FiRepeat className="w-5 h-5" />,
      },
    ],
    quote: "I'm not worried about COD orders and subsequent RTO possibility anymore.",
    quoteName: "Aman Verma, Founder",
  },
];

export default function CaseStudies() {
  return (
    <section className="py-20 px-8 lg:px-16 bg-base-200">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Case Study
          </h2>
        </div>

        {/* Case Study Cards */}
        {caseStudies.map((study, index) => (
          <div key={index} className="card bg-base-100 shadow-xl">
            <div className="card-body">
              {/* Store Info */}
              <div className="flex items-center gap-4 mb-6">
                {study.logo ? (
                  <img
                    src={study.logo}
                    alt={study.storeName}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-xl">
                    {study.storeName.charAt(0)}
                  </div>
                )}
                <div>
                  {study.url ? (
                    <a
                      href={study.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="card-title text-xl hover:text-primary transition-colors"
                    >
                      {study.storeName}
                    </a>
                  ) : (
                    <h3 className="card-title text-xl">{study.storeName}</h3>
                  )}
                  <p className="text-sm opacity-60">{study.industry}</p>
                </div>
              </div>

              {/* Metrics Grid */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                {study.metrics.map((metric, metricIndex) => (
                  <div
                    key={metricIndex}
                    className="stat bg-base-200 rounded-lg p-4"
                  >
                    <div className="stat-figure text-primary">
                      {metric.icon}
                    </div>
                    <div className="stat-title text-xs">{metric.label}</div>
                    <div className="stat-value text-2xl text-success">
                      {metric.value}
                    </div>
                    <div className="stat-desc text-xs">{metric.description}</div>
                  </div>
                ))}
              </div>

              {/* Quote */}
              {study.quote && (
                <blockquote className="border-l-4 border-primary pl-4 italic opacity-80">
                  <p>"{study.quote}"</p>
                  {study.quoteName && (
                    <footer className="text-sm mt-2 not-italic opacity-60">
                      — {study.quoteName}
                    </footer>
                  )}
                </blockquote>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
